// import axios from "./APIUtils";
import axios from "./axios.provider";
import { apiConfig } from "./config";
import { parseList } from "./utility";

const GetVendorList = async function() {
  try {
    const response = await axios.get(
      `${apiConfig}/api/Vendor/getAllVendorAccount`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const GetVendorListByStatus = async function(status) {
  try {
    const response = await axios.get(
      `${apiConfig}/api/Vendor/getAllVendorAccountByStatus/${status}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const GetVendorListByApprovalStatus = async function(status) {
  try {
    const response = await axios.get(
      `${apiConfig}/api/Vendor/getAllVendorListByApprovalStatus/${status}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const GetVendorListByRegisteredRevised = async function() {
  try {
    const response = await axios.get(
      `${apiConfig}/api/Vendor/getAllVendorListByRegisteredRevised`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const GetVendorAccountById = async function(id) {
  try {
    const response = await axios.get(
      `${apiConfig}/api/Vendor/getVendorAccountByID/${id}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const GetVendorInfoById = async function(id) {
  try {
    const response = await axios.get(
      `${apiConfig}/api/Vendor/GetVendorInfoByID/${id}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const UpdateVendorInfo = async function(model) {
  try {
    const response = await axios.put(
      `${apiConfig}/api/Vendor/UpdateVendorInfo`,
      model
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const GetVendorCategory = async function(userName, id) {
  try {
    const response = await axios.get(
      `${apiConfig}/api/Vendor/GetVendorCategories/${userName}/${id}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const AddVendorCategory = async function(model) {
  try {
    const response = await axios.post(
      `${apiConfig}/api/Vendor/AddVendorCategory`,
      model
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const DeleteVendorCategory = async function(id) {
  try {
    const response = await axios.delete(
      `${apiConfig}/api/Vendor/DeleteVendorCategory/${id}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const GetVendorLocation = async function(userName, id) {
  try {
    const response = await axios.get(
      `${apiConfig}/api/Vendor/GetVendorLocation/${userName}/${id}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const AddVendorLocation = async function(model) {
  try {
    const response = await axios.post(
      `${apiConfig}/api/Vendor/AddVendorLocation`,
      model
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const DeleteVendorLocation = async function(id) {
  try {
    const response = await axios.delete(
      `${apiConfig}/api/Vendor/DeleteVendorLocation/${id}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const GetVendorAttachment = async function(userName) {
  try {
    const response = await axios.get(
      `${apiConfig}/api/Vendor/getAllAttachment/${userName}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const ApprovalVendor = async function(model) {
  try {
    const response = await axios.post(
      `${apiConfig}/api/Vendor/VendorApproval`,
      model
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const ForgotPassword = async function(userName) {
  try {
    const response = await axios.post(
      `${apiConfig}/api/Vendor/ForgotPassword/${userName}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const UnlockAccount = async function(id) {
  try {
    const response = await axios.post(
      `${apiConfig}/api/Vendor/UnlockAccount/${id}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const SetVendorStatus = async function(model) {
  try {
    const response = await axios.post(
      `${apiConfig}/api/Vendor/SetStatus`,
      model
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const _vendorservice = {
  GetVendorList,
  GetVendorListByStatus,
  GetVendorAccountById,
  GetVendorInfoById,
  UpdateVendorInfo,
  AddVendorCategory,
  GetVendorCategory,
  DeleteVendorCategory,
  GetVendorLocation,
  AddVendorLocation,
  DeleteVendorLocation,
  GetVendorAttachment,
  ApprovalVendor,
  ForgotPassword,
  UnlockAccount,
  SetVendorStatus,
  GetVendorListByApprovalStatus,
  GetVendorListByRegisteredRevised,
};
